<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <p
                  class="h-t-name"
                  v-if="currentUser.ACTIVE_ROLE_CODE !== 'lizing'"
                >
                  Методики
                </p>
                <p
                  class="h-t-name"
                  v-if="currentUser.ACTIVE_ROLE_CODE === 'lizing'"
                >
                  МЕТОДИКИ ("ЛИЗИНГОВЫЕ ПРОЕКТЫ")
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content content_table">
          <div class="methods-info">
            <p>Нормативно-методическая документация</p>
            <p>
              Просим ознакомиться с представленными нормативными документами по
              отбору проектов для финансовой поддержки со стороны Фонда, формами
              документов, заполняемых для подачи документов и методическими
              рекомендациями по их заполнению.
            </p>
          </div>
          <!-- methods-info -->
          <div class="methods-box" v-for="methodic in methodics">
            <h4 class="methods-box__title">
              {{ methodic.SECTION_NAME }}
            </h4>
            <div class="row myrow" v-for="document in methodic.DOCUMENTS">
              <div class="col-xs-10 methods-box__text">
                {{ document.NAME }}
              </div>
              <div class="col-xs-2">
                <div class="methods-views pull-right">
                  <div class="methods-views__l">
                    <a
                      :href="document.FILE"
                      target="_blank"
                      @click="addCount(document.ID)"
                      :class="'methods-link__' + document.TYPE_FILE"
                    ></a>
                  </div>
                  <div class="methods-views__i"></div>
                  <div class="methods-views__n">
                    {{ document.DOWNLOAD_CNT }}
                  </div>
                </div>
              </div>
            </div>
            <div v-for="child in methodic.CHILD">
              <div class="row myrow">
                <div class="col-xs-10 methods-box__suptitle">
                  {{ child.SECTION_NAME }}
                </div>
              </div>
              <div class="row myrow" v-for="document in child.DOCUMENTS">
                <div class="col-xs-10 methods-box__text">
                  {{ document.NAME }}
                </div>
                <div class="col-xs-2">
                  <div class="methods-views pull-right">
                    <div class="methods-views__l">
                      <a
                        :href="document.FILE"
                        target="_blank"
                        @click="addCount(document.ID)"
                        :class="'methods-link__' + document.TYPE_FILE"
                      ></a>
                    </div>
                    <div class="methods-views__i"></div>
                    <div class="methods-views__n">
                      {{ document.DOWNLOAD_CNT }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- methods-box -->
          <br /><br /><br /><br /><br />
        </div>
      </div>
      <!-- wraper -->
    </div>
    <slot name="footer"></slot>
  </fragment>
</template>

<script>
import {
  FETCH_METHODICS,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import { MethodicsService, ProjectsService } from "@/common/api.service";

export default {
  name: "Methodics",
  computed: {
    ...mapGetters(["currentUser", "methodics"])
  },
  methods: {
    fetchMethodics() {
      if (this.currentUser.ACTIVE_ROLE_CODE === "lizing") {
        this.$store.dispatch(FETCH_METHODICS, "1");
      } else {
        this.$store.dispatch(FETCH_METHODICS, "");
      }
    },
    addCount(id) {
      MethodicsService.setNewCountView(id);
      this.fetchMethodics();
    }
  },
  mounted() {
    this.$store.dispatch(SET_MAIN_MENU, []);
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
        } else {
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
      });
    } else {
      this.$store.dispatch(SET_MAIN_MENU, [
        {
          name: "Мои проекты",
          route: "Projects"
        }
      ]);
    }
    this.fetchMethodics();
  }
};
</script>
